import styled from 'styled-components';

const LayoutContainer = styled.div`
  min-height: 100vh;
`;

const ContentContainer = styled.div`
  flex: none;
  padding: 0;
`;

export { LayoutContainer, ContentContainer };
